const DATA_URL = "https://d31t81fmjwumyk.cloudfront.net/contributors.json";

const FIELDS = {
    Participant: {
        short: "Participant"
    },
    ZipCode: {
        short: "ZIP",
        long: "ZIP Code"
    },
    DataSourceType: {
        short: "Data Source",
        long: "Data Source Type"
    },
    ADT: {
        short: "ADT",
        long: "Admit, Discharge, Transfer",
        isDate: true
    },
    LAB: {
        short: "LAB",
        long: "Laboratory",
        isDate: true
    },
    RAD: {
        short: "RAD",
        long: "Radiology",
        isDate: true
    },
    TRN: {
        short: "TRN",
        long: "Transcription",
        isDate: true
    },
    Imaging: {
        short: "Imaging",
        isDate: true
    },
    ReferenceLabs: {
        short: "Reference Labs",
        long: "Reference LABS (LabCorp, Quest, Lab Alliance)",
        isDate: true
    },
    ReceivingCCDs: {
        short: "Receiving CCDs",
        long: "Receiving Continuity of Care Documents",
        isDate: true
    },
    EKGs: {
        short: "EKGs",
        long: "Electrocardiogram"
    },
    VisitSummary: {
        short: "Visit Summary"
    },
    Allergies: {
        short: "Allergies"
    },
    CareManagement: {
        short: "Care Management"
    },
    CareTeamMembers: {
        short: "Care Team Members"
    },
    ConditionsProblems: {
        short: "Conditions / Problems"
    },
    Immunization: {
        short: "Immunization"
    },
    Medications: {
        short: "Medications"
    },
    Orders: {
        short: "Orders"
    },
    OrderResults: {
        short: "Order Results"
    },
    PatientDemographics: {
        short: "Patient Demographics"
    },
    Procedures: {
        short: "Procedures"
    },
    SmokingStatus: {
        short: "Smoking Status"
    },
    VisitInformation: {
        short: "Visit Information"
    },
    Vitals: {
        short: "Vitals"
    }
};

export { DATA_URL, FIELDS };
